import { Box, Button } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Palette } from '@/themes/themeOverrides/Palette';
import CheckmarkSmallIcon from '@/assets/icons/checkmark-small-icon.svg?react';

const StyledSidebarSteps = styled(Box)(() => ({
    backgroundColor: Palette.gray.gray75,
    height: 'fit-content',
    borderRadius: '12px',
    '& .steps-sidebar-list': {
        padding: '0',
        '& .sidebar-step': {
            width: '100%',
            backgroundColor: 'transparent',
            display: 'flex',
            justifyContent: 'flex-start',
            gap: '12px',
            '&:hover': {
                outline: `2px solid ${Palette.gray.gray300}`,
                outlineOffset: '-2px',
            },
            '& .sidebar-step-number': {
                backgroundColor: Palette.gray.gray300,
                outlineOffset: '-2px',
                width: '20px',
                height: '20px',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '10px',
                fontWeight: 700,
            },
            '& .sidebar-step-number-completed': {
                backgroundColor: Palette.green.green300,
                outline: `2px solid ${Palette.green.green600}`,
            },
        },
        '& .active-step': {
            backgroundColor: Palette.white,
            outline: `2px solid ${Palette.gray.gray150}`,
            outlineOffset: '-2px',
            boxShadow: Palette.boxShadow.elevation2,
            '& .sidebar-step-number': {
                backgroundColor: Palette.yellow.yellow300,
                outline: `2px solid ${Palette.yellow.yellow500}`,
                outlineOffset: '-2px',
            },
            '& .sidebar-step-number-completed': {
                backgroundColor: Palette.green.green300,
                outline: `2px solid ${Palette.green.green600}`,
            },
        },
    },
}));

export const SidebarSteps = ({
    steps = [],
    activeIndex = 0,
    onSelect = () => {},
    isStepCompleted = () => false,
    isStepEnabled = () => true,
    allStepsCompleted = false,
}) => {
    return (
        <StyledSidebarSteps className='steps-sidebar'>
            <Box className='steps-sidebar-list'>
                {steps.map((label, index) => {
                    const isActive = index === activeIndex;
                    const isSummary = index === steps.length - 1;
                    const showCompleted = !isActive && (isSummary ? allStepsCompleted : isStepCompleted(index));
                    const numberClass = showCompleted ? 'sidebar-step-number sidebar-step-number-completed' : 'sidebar-step-number';

                    return (
                        <Button
                            key={label}
                            className={isActive ? 'active-step sidebar-step' : 'sidebar-step'}
                            color={isActive ? 'primary' : 'inherit'}
                            type='button'
                            disabled={!isStepEnabled(index)}
                            onClick={() => {
                                if (isStepEnabled(index)) onSelect(index);
                            }}
                        >
                            <Box className={numberClass}>{showCompleted ? <CheckmarkSmallIcon /> : index + 1}</Box>
                            <Box className='sidebar-step-label'>{label}</Box>
                        </Button>
                    );
                })}
            </Box>
        </StyledSidebarSteps>
    );
};

SidebarSteps.propTypes = {
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
    activeIndex: PropTypes.number.isRequired,
    onSelect: PropTypes.func.isRequired,
    isStepCompleted: PropTypes.func,
    isStepEnabled: PropTypes.func,
};

export default SidebarSteps;
